import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router-dom';
import AppShell from '../AppShell';
import Router from '../routes/Router';

const sentryEnhancedCreateBrowserRouter = Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

/**
 * React Router v6 data API ile oluşturulmuş, Sentry navigasyon izlemesi eklenmiş router.
 * `wrapCreateBrowserRouter` sayfa geçişlerinde performans transaction’larını üretir.
 *
 * @param {object} [opts] — `createBrowserRouter` ikinci argümanı (ör. `future`)
 * @returns {import('react-router-dom').DataRouter}
 */
export function createAppRouter(opts = {}) {
  return sentryEnhancedCreateBrowserRouter(
    [
      {
        element: <AppShell />,
        children: Router,
      },
    ],
    opts
  );
}
